import {ref} from 'vue'

export function useAddressField() {
  const showAddressFields = ref(false)
  const showCustomAddressLink = ref(false)

  const addressValueChange = async (newVal) => {
    try {
      showCustomAddressLink.value = newVal === 'no-address-found'
    } catch (error) {
      console.error('Error in addressValueChange:', error)
    }
  };

  const toggleCustomAddress = () => {
    showAddressFields.value = !showAddressFields.value;
  }

  return {
    showAddressFields,
    showCustomAddressLink,
    addressValueChange,
    toggleCustomAddress,
  }
}
